exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".picnic-content-editor .ProseMirror{min-height:1em;padding:0!important;width:100%}.picnic-content-editor .ProseMirror:focus{outline:none!important}.ps-editor p{margin-bottom:12px!important;line-height:1.4!important;color:\"#4e3d42\"}.ps-editor p:last-of-type{margin-bottom:0!important}", ""]);

// exports
